import { render, staticRenderFns } from "./SiteAdmin.vue?vue&type=template&id=46675447&scoped=true&"
import script from "./SiteAdmin.vue?vue&type=script&lang=js&"
export * from "./SiteAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46675447",
  null
  
)

export default component.exports